import React from "react";
import {DatePicker} from "antd";
import {DatePickerInputBoxProps} from "./interface";
import {SplitInputWrapperProps, InputWrapper} from "../../functions";
import {CONSTANT} from "../../../../config/Constant";
import {validations} from "../../../../config/validations/validations";
import {toLowerCaseWithUnderscore} from "../../../AgGridWrapper/utils/commonFunctions";

const DatePickerInputBox: React.FC<DatePickerInputBoxProps> = (props) => {
    const {
        formProps: {rules = [], ...formProps},
        inputProps: {format = CONSTANT.DATE_FORMAT, ...inputProps},
    } = SplitInputWrapperProps(props);

    if (formProps?.required) {
        rules.filter((rule: any) => rule.required).length === 0 &&
            rules.push(validations.required.other());
    }
    return (
        <InputWrapper
            name={formProps?.label && toLowerCaseWithUnderscore(formProps?.label)}
            rules={rules}
            {...formProps}
        >
            <DatePicker format={format} {...inputProps} />
        </InputWrapper>
    );
};

export default DatePickerInputBox;
